<template>
  <div class="tabs">
    <el-tabs
      type="border-card" value="contractForm"
      @tab-click="handleTabClick"
    >
      <el-tab-pane :label="tabTitle" name="contractForm">
        <contractForm
          :rows="detailData" :type="detailType"
          @closeDetail="closeDetail"
        />
      </el-tab-pane>
      <el-tab-pane
        v-if="isShowLog" :label="$t('basicData.OperationalLogs')" name="operationLog"
      >
        <operationLog :rows="detailData" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import contractForm from './contractForm.vue';
import operationLog from './operationLog.vue';

export default {
  // name: 'TabForm',

  components: {
    contractForm,
    operationLog
  },

  props: {
    detailType: { // 详情类型 1:新增 2:编辑
      type: Number,
      default: 1
    },
    detailData: { // 详情数据
      type: Object,
      default: () => {
        return {};
      }
    }
  },

  data() {
    return {};
  },

  computed: {
    isShowLog() {
      return this.detailType !== 1;
    },

    tabTitle() {
      return this.detailType === 1 ? this.$t('basicData.AddContract') : this.$t('basicData.ContractDetails');
    }
  },

  methods: {
    handleTabClick(tab) {
      // 标签页切换时的回调
      this.$nextTick(() => {
        // 调用当前激活组件的特定方法
        const activeComponent = this.$refs[tab.name];
        if (activeComponent && typeof activeComponent.onTabActivated === 'function') {
          activeComponent.onTabActivated();
        }
      });
    },

    closeDetail() {
      this.$emit('closeDetail');
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .el-tabs {
  border: none;
}

::v-deep .el-tabs--border-card>.el-tabs__content {
  padding: 0;
}
</style>
